import api from "../http";

export default class PaydayAPI {
    static async getAll() {
        return api.get('/payday');
    }

    static async create(item) {
        return api.post('/payday/', item);
    }

    static async update(item) {
        return api.post('/payday/edit', item);
    }

    static async remove(id) {
        return api.get('/payday/remove?id=' + id);
    }

    static async getAllRanges() {
        return api.get('/payday/range');
    }

    static async createRange(item) {
        return api.post('/payday/range', item);
    }

    static async editRange(item) {
        return api.post('/payday/range/edit', item);
    }

    static async removeRange(id) {
        return api.get('/payday/range/remove?id=' + id);
    }
}